import React from 'react'

import { Banner, ButtonClean } from '@fourthwall/components'

interface CombinedAlertProps {
  combinedName: string
  combinedLink: string
}

export const CombinedAlert = ({ combinedName, combinedLink }: CombinedAlertProps) => {
  return (
    <Banner
      appearance="warning"
      title={
        <>
          This product is part of a combined listing:{' '}
          <ButtonClean to={combinedLink} label={combinedName} />. It’s not available on the shop as
          a separate product.
        </>
      }
    />
  )
}
